export default __webpack_public_path__ + "static/media/people.5cd2d6fb.png";